module.exports = __webpack_public_path__ + "media/images/join-3-49a147b20b1355417744049ff14520fc.jpg";